import { useContext } from 'react';
import { SchedulingChartsDataContext } from '../contexts/SchedulingChartsDataContext';

export const useSchedulingChartsDataContext = () => {
    return useContext(SchedulingChartsDataContext);
};
